import * as React from "react"
const TickMarkComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={14} height={10} {...props}>
    <title>{"Atoms/UI/Icons/Tick"}</title>
    <path
      fill="#000"
      fillRule="nonzero"
      d="M13.144.144C7.964 5.08 7.32 5.814 4.303 8.698L.848 5.68a.54.54 0 0 0-.724.011.479.479 0 0 0 .047.688l3.81 3.33a.538.538 0 0 0 .691-.015c3.42-3.256 3.767-3.725 9.18-8.88a.472.472 0 0 0 .101-.548c-.229-.347-.547-.318-.809-.122Z"
    />
  </svg>
)
export default TickMarkComponent
